/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PayType } from './PayType';
import {
    PayTypeFromJSON,
    PayTypeFromJSONTyped,
    PayTypeToJSON,
    PayTypeToJSONTyped,
} from './PayType';

/**
 * 
 * @export
 * @interface ShowPayTypeResponse
 */
export interface ShowPayTypeResponse {
    /**
     * 
     * @type {PayType}
     * @memberof ShowPayTypeResponse
     */
    data: PayType;
}

/**
 * Check if a given object implements the ShowPayTypeResponse interface.
 */
export function instanceOfShowPayTypeResponse(value: object): value is ShowPayTypeResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShowPayTypeResponseFromJSON(json: any): ShowPayTypeResponse {
    return ShowPayTypeResponseFromJSONTyped(json, false);
}

export function ShowPayTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowPayTypeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': PayTypeFromJSON(json['data']),
    };
}

  export function ShowPayTypeResponseToJSON(json: any): ShowPayTypeResponse {
      return ShowPayTypeResponseToJSONTyped(json, false);
  }

  export function ShowPayTypeResponseToJSONTyped(value?: ShowPayTypeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PayTypeToJSON(value['data']),
    };
}

